import * as filter from '@/store/modules/procedure/filter.js'
import { DataService } from '@/services/DataService.js'
import { mapBackendProceduresToFrontend } from '@/utils/procedure.js'

export const namespaced = true

export const modules = {
  filter
}

export const state = {
  statuses: [ // TODO: грузить с бека
    { id: 0, code: 'draft', name: 'Формирование' },
    { id: 1, code: 'open', name: 'Открыт' },
    { id: 2, code: 'agreement', name: 'Согласование' },
    { id: 3, code: 'closed', name: 'Закрыт' }
  ],
  bid_directions: [ // TODO: грузить с бека
    { id: 0, code: 'all', name: 'Любой' },
    { id: 1, code: 'buy', name: 'Покупка' },
    { id: 2, code: 'sell', name: 'Продажа' }
  ],
  periods: [ // TODO: грузить с бека
    { id: 0, name: 'День' },
    { id: 1, name: 'Декада' },
    { id: 2, name: 'Месяц' },
    { id: 3, name: 'Квартал' },
    { id: 4, name: 'Год' },
    { id: 5, name: 'С-По' }
  ],
  managers: [],
  participants: [],
  organizations: [],
  procedures: [],
  stats: {}
}

export const getters = {
  procedures (state) {
    return state.procedures
  },
  procedure (state) {
    return (id) => {
      return state.procedures.find((p) => {
        return p.id === id
      })
    }
  },
  stats (state) {
    return state.stats
  },
  totalCount (state, getters) {
    const statuses = Object.values(getters['filter/status'])
    const stats = state.stats
    let counts = 0
    if (statuses.length) {
      counts = statuses.map(s => stats[s])
    } else {
      counts = Object.values(stats)
    }
    const total = counts.filter(v => v).reduce((acc, v) => acc + v, 0)
    return total % 10 ? Math.floor(total / 10) + 1 : total / 10
  },
  statuses (state) {
    return state.statuses
  },
  periods (state) {
    return state.periods
  },
  bid_directions (state) {
    return state.bid_directions
  },
  organizations (state) {
    return state.organizations
  },
  managers (state, getters, rootState, rootGetters) {
    return rootGetters['companyInfo/managers']
  },
  participant (state) {
    return (id) => {
      return state.participants.find((p) => {
        return p.id === id
      })
    }
  },
  filteredProcedures (state, getters) {
    // filter/period: (...) ???
    return getters.procedures
  },
  apiParams: (state, getters, rootState, rootGetters) => page => {
    const procTypes = { 1: 'BUY', 2: 'SELL' }
    let params = {
      companyId: rootGetters['user/user'].companyId,
      employeeId: getters['filter/manager'],
      type: procTypes[getters['filter/bid_direction']],
      states: getters['filter/status'].length ? getters['filter/status'] : null,
      offset: (page - 1) * 10,
      limit: 10
    }

    params = Object.entries(params).filter(([k, v]) => v !== null && v !== undefined)
    return Object.fromEntries(params)
  },
  makeProcedure (state) {
    return ({ procedures }) => mapBackendProceduresToFrontend(procedures)
  }
}

export const mutations = {
  SET_PROCEDURES (state, data = []) {
    state.procedures = data
  },
  SET_MANAGERS (state, data = []) {
    state.managers = data
  },
  SET_DEPARTMETS (state, data = []) {
    state.departments = data
  },
  SET_PROCEDURES_STATS (state, data) {
    state.stats = data
  }
}

export const actions = {
  async load ({ commit, getters, dispatch }, page) {
    dispatch('loadStatusStats')

    const { data: { procedures } } = await DataService.getProcedures(getters.apiParams(page))
    await setProcedures(procedures, commit)
  },
  async loadStatusStats ({ commit, getters }) {
    const params = [{
      key: 'departmentId',
      value: getters['filter/organization']
    }, {
      key: 'employeeId',
      value: getters['filter/manager']
    }, {
      key: 'type',
      value: getters['filter/bid_direction'] === 0 ? null : getters['filter/bid_direction'] === 1 ? 'BUY' : 'SELL'
    }, {
      key: 'from',
      value: getters['filter/period']?.start
    }, {
      key: 'to',
      value: getters['filter/period']?.end
    }].reduce((acc, p) => {
      if (p.value) {
        acc[p.key] = p.value
      }
      return acc
    }, {})

    const stats = await DataService.getProceduresStats(params)
    const proceduresStats = stats.data.procedures_stats.reduce(function (map, obj) {
      map[obj.group] = obj.count || 0
      return map
    }, {})

    commit('SET_PROCEDURES_STATS', proceduresStats)
  }
}

async function setProcedures (data = [], commit) {
  const procedures = mapBackendProceduresToFrontend(data)
  await commit('SET_PROCEDURES', procedures)
}
